import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';

dayjs.locale('zh-cn');

export const formatDateTime: (date: Date) => string = (date) => dayjs(date).format('YYYY 年 MM 月 DD 日');
export const compareDateTime: (a:number, b:number) => boolean = (a, b) => a > b;
